import Link from 'next/link';
import type { SocialComment, SocialPost } from '@/lib/social/types';
import { socialPostPath, socialProfilePath } from '@/lib/social/links';
import { Avatar, Timestamp } from '../ui';
import { RichPostText } from '../rich-text';

export function ReplyContext({ post, parent }: { post: SocialPost; parent?: SocialComment }) {
  const source = parent ?? post;
  const href = parent?.permalink || `${socialPostPath(post)}${parent ? `#comment-${parent.id}` : ''}`;
  return <div className="social-reply-context">
    <div className="social-reply-context-avatar"><Avatar profile={source.author} className="size-10" /><span aria-hidden="true" /></div>
    <div className="min-w-0 flex-1 pb-3">
      <div className="social-post-byline">
        <Link href={socialProfilePath(source.author.handle)} className="social-post-identity"><span className="social-post-name">{source.author.displayName}</span><span className="social-post-handle">@{source.author.handle}</span></Link>
        <Timestamp value={source.createdAt} />
      </div>
      <div className="mt-1 line-clamp-3 text-sm"><RichPostText body={source.body} /></div>
      {!!source.media?.length && <p className="mt-1 text-xs text-muted-foreground">{source.media[0].kind === 'video' ? 'Video' : `${source.media.length} ${source.media.length === 1 ? 'photo' : 'photos'}`} · <Link href={href} className="underline">View {parent ? 'reply' : 'post'}</Link></p>}
      <p className="mt-2 text-xs text-muted-foreground">Replying to <Link href={socialProfilePath(source.author.handle)} className="font-medium text-foreground">@{source.author.handle}</Link></p>
    </div>
  </div>;
}
